module.exports = __webpack_public_path__ + "img/meta-front-end-developer.b72ae9d1.png";